import React,{useState} from 'react'
import { Grid } from  'react-loader-spinner'


const spinnerStyle = {
    position: "absolute", 
    top: "0", 
    width:'100%',
    height:'100%',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
   
}


function LoadingSpinner() {

  return (
        <div className="spinner-container" style={spinnerStyle} >
          <Grid
            height="70"
            width="70"
            color="#309197"
            ariaLabel="grid-loading"
            radius="12.5"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
  )
}

export default LoadingSpinner